/** @jsxImportSource theme-ui */
import { Box, Button, Text } from 'theme-ui'
import { useEffect, useState } from 'react'

const ABTestDebug = () => {
  const [currentVariant, setCurrentVariant] = useState<string | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Função para ler cookie
    const getCookie = (name: string): string | null => {
      if (typeof document === 'undefined') return null
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) return parts.pop()?.split(';').shift() || null
      return null
    }

    const variant = getCookie('ab-hero-component')
    setCurrentVariant(variant)

    // Mostrar apenas em desenvolvimento
    setIsVisible(process.env.NODE_ENV === 'development')
  }, [])

  const setCookie = (name: string, value: string) => {
    document.cookie = `${name}=${value}; path=/; max-age=${60 * 60 * 24 * 7}`
    setCurrentVariant(value)
    window.location.reload()
  }

  const clearCookie = () => {
    document.cookie =
      'ab-hero-component=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT'
    setCurrentVariant(null)
    window.location.reload()
  }

  if (!isVisible) return null

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 4,
        right: 4,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        padding: 3,
        borderRadius: 2,
        zIndex: 9999,
        fontSize: 1,
        minWidth: '200px',
      }}
    >
      <Text sx={{ fontWeight: 'bold', mb: 2, display: 'block' }}>
        A/B Test Debug
      </Text>

      <Text sx={{ mb: 2, display: 'block' }}>
        Variante atual: <strong>{currentVariant || 'Nenhuma'}</strong>
      </Text>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Button
          onClick={() => setCookie('ab-hero-component', 'image')}
          sx={{
            fontSize: 0,
            py: 1,
            color: currentVariant === 'image' ? 'white' : 'primary',
            backgroundColor: currentVariant === 'image' ? 'primary' : 'muted',
          }}
        >
          Forçar Imagem
        </Button>

        <Button
          onClick={() => setCookie('ab-hero-component', 'video')}
          sx={{
            fontSize: 0,
            py: 1,
            color: currentVariant === 'video' ? 'white' : 'primary',
            backgroundColor: currentVariant === 'video' ? 'primary' : 'muted',
          }}
        >
          Forçar Vídeo
        </Button>

        <Button
          onClick={clearCookie}
          sx={{
            fontSize: 0,
            py: 1,
            backgroundColor: 'secondary',
          }}
        >
          Limpar Cookie
        </Button>
      </Box>
    </Box>
  )
}

export default ABTestDebug
